module.exports = __webpack_public_path__ + "media/images/blog/hero-background-ac7b1b69b868deeddfa2a09ec3e41040.svg";